import React, { useContext, useEffect, useState } from "react";
import CryptoContext from "../context/crypto/cryptoContext";
import { AiFillCaretDown, AiFillCaretUp } from "react-icons/ai";
import Loader from "../components/Loader";
import moment from "moment";
import getSymbolFromCurrency from "currency-symbol-map";
import NumberFormat from "react-number-format";
import { compareProgress} from "../helpers/format";
import CompareChart from "./CompareCryptoChart";
import ParameterContext from "../context/parameter/parameterContext";
import BreadCrumbs from "../components/BreadCrumbs";
import { useWindowSize } from "react-use";
const Compare = () => {
  const {
    getCompareCryptoCoinData1,
    cryptoCoinData1,
    compareCryptoCoinData1,
    getCompareCryptoCoinData2,
    cryptoCoinData2,
    compareCryptoCoinData2,
    cryptoData,
    convt,
  } = useContext(CryptoContext);
  const { width } = useWindowSize();
  const { setTimeInChart} = useContext(ParameterContext);
  const [dropdown1, setDropdown1] = useState(false);
  const [dropdown2, setDropdown2] = useState(false);

  const localCurrency = useState(convt)[0];

  const currencySymbol = getSymbolFromCurrency(
    localCurrency !== convt ? localCurrency : convt
  );
  const handleCompareClick1 = () => {
    setDropdown1(!dropdown1);
    setDropdown2(false);
  };
  const handleCrypto1Click = (id) => {
    getCompareCryptoCoinData1(id);
  };
  const handleCompareClick2 = () => {
    setDropdown2(!dropdown2);
    setDropdown1(false);
  };
  const handleCrypto2Click = (id) => {
    getCompareCryptoCoinData2(id);
  };
  useEffect(() => {
    setTimeInChart("ally");

    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (cryptoData && cryptoData.length > 0) {
      getCompareCryptoCoinData1(cryptoCoinData1);

      getCompareCryptoCoinData2(cryptoCoinData2);
    }

    // if (cryptoCoinData1 && cryptoCoinData1.length > 0) {
    //   setTimeout(() => {
    //     getCompareCryptoCoinData1Sparkline(
    //       cryptoCoinData1,
    //       "All",
    //       localCurrency
    //     );
    //   }, 1000);
    // }
    // if (cryptoCoinData2 && cryptoCoinData2.length > 0) {
    //   setTimeout(() => {
    //     getCompareCryptoCoinData2Sparkline(
    //       cryptoCoinData2,
    //       "All",
    //       localCurrency
    //     );
    //   }, 2000);
    // }

    //eslint-disable-next-line
  }, [convt, cryptoData]);
  const routes = [
    { path: "/", name: "Cryptos" },
    { path: "/compare", name: "Compare" },
  ];
  return (
    <div className="Compare">
      <div className="Compare__container">
        <BreadCrumbs routes={routes} />
        {compareCryptoCoinData1 &&
        compareCryptoCoinData1.length > 0 &&
        compareCryptoCoinData2 &&
        compareCryptoCoinData2.length > 0 ? (
          <div
            style={{
              background: "rgba(245, 237, 245, 0.5)",
              display: "flex",
              flexDirection: width < 720 ? "column" : "row",
              padding: "5px 5px",
              gap: "5px",
            }}
          >
            <div>
              <>
                <div className="Compare__select1" onClick={handleCompareClick1}>
                  {compareCryptoCoinData1[0].logo_url &&
                  compareCryptoCoinData1[0].name &&
                  compareCryptoCoinData1[0].id ? (
                    <>
                      
                      <img
                        src={compareCryptoCoinData1[0].logo_url}
                        alt={compareCryptoCoinData1[0].name}
                        style={{
                          width: "30px",
                          height: "30px",
                          borderRadius: "50%",
                        }}
                      />
                      <p>
                        {compareCryptoCoinData1[0].id}
                        {compareCryptoCoinData1[0].name}
                      </p>
                    </>
                  ) : (
                    <></>
                  )}
                  {dropdown1 ? <AiFillCaretUp /> : <AiFillCaretDown />}
                  {dropdown1 ? (
                    <div className="Compare__cryptoData1">
                      {cryptoData.length > 0 ? (
                        cryptoData.map((d, index) => (
                          <div
                            className="Compare__search__dropdown__container"
                            onClick={() => handleCrypto1Click(d.id)}
                            key={index}
                          >
                            {d.logo_url && d.name ? (
                              <>
                                
                                <img src={d.logo_url} alt={d.name} />
                                <p>
                                  {d.id} {d.name}
                                </p>
                              </>
                            ) : (
                              <></>
                            )}
                          </div>
                        ))
                      ) : (
                        <></>
                      )}
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              </>
            </div>
            <div>
              <>
                <div className="Compare__select1" onClick={handleCompareClick2}>
                  {compareCryptoCoinData2[0].logo_url &&
                  compareCryptoCoinData2[0].name &&
                  compareCryptoCoinData2[0].id ? (
                    <>
                      <img
                        src={compareCryptoCoinData2[0].logo_url}
                        alt={compareCryptoCoinData2[0].name}
                        style={{
                          width: "30px",
                          height: "30px",
                          borderRadius: "50%",
                        }}
                      />
                      <p>
                        {compareCryptoCoinData2[0].id}
                        {compareCryptoCoinData2[0].name}
                      </p>
                    </>
                  ) : (
                    <></>
                  )}

                  {dropdown2 ? <AiFillCaretUp /> : <AiFillCaretDown />}
                  {dropdown2 ? (
                    <div className="Compare__cryptoData1">
                      {cryptoData.length > 0 ? (
                        cryptoData.map((d, index) => (
                          <div
                            className="Compare__search__dropdown__container"
                            onClick={() => handleCrypto2Click(d.id)}
                            key={index}
                          >
                            {d.logo_url && (
                              <img src={d.logo_url} alt={d.name} />
                            )}
                            <p>
                              {d.id && d.id} {d.name && d.name}
                            </p>
                          </div>
                        ))
                      ) : (
                        <></>
                      )}
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              </>
            </div>
          </div>
        ) : (
          <></>
        )}

        {compareCryptoCoinData1 &&
        compareCryptoCoinData1.length > 0 &&
        compareCryptoCoinData2 &&
        compareCryptoCoinData2.length > 0 ? (
          <div style={{ width: "100%", overflow: "auto" }}>
            <CompareChart
              currencySymbol={currencySymbol}
              localCurrency={localCurrency}
              larger={
                compareCryptoCoinData1[0].rank > compareCryptoCoinData2[0].rank
              }
            />
            <table
              style={{
                width: "1200px",
                marginTop: "20px",
              }}
            >
              <tr>
                <td>Rank</td>
                <td>
                  {compareCryptoCoinData1[0].rank
                    ? compareCryptoCoinData1[0].rank
                    : "NA"}
                </td>
                <td>
                  {compareCryptoCoinData2[0].rank
                    ? compareCryptoCoinData2[0].rank
                    : "NA"}
                </td>
                <td></td>
              </tr>
              <tr>
                <td>Price</td>
                <td>
                  {compareCryptoCoinData1[0].price ? (
                    <NumberFormat
                      displayType={"text"}
                      thousandSeparator={true}
                      value={compareCryptoCoinData1[0].price}
                      prefix={`${currencySymbol} `}
                    />
                  ) : (
                    "NA"
                  )}
                </td>
                <td>
                  {compareCryptoCoinData2[0].price ? (
                    <NumberFormat
                      displayType={"text"}
                      thousandSeparator={true}
                      value={compareCryptoCoinData2[0].price}
                      prefix={`${currencySymbol} `}
                    />
                  ) : (
                    "NA"
                  )}
                </td>
                <td>
                  {compareCryptoCoinData2[0].price &&
                  compareCryptoCoinData1[0].price ? (
                    <>
                      <div
                        className="Compare__progressbar__yellow"
                        style={{
                          width: compareProgress(
                            compareCryptoCoinData1[0].price,
                            compareCryptoCoinData2[0].price
                          ),
                        }}
                      ></div>
                      <div
                        className="Compare__progressbar__violet"
                        style={{
                          width: compareProgress(
                            compareCryptoCoinData2[0].price,
                            compareCryptoCoinData1[0].price
                          ),
                        }}
                      ></div>
                    </>
                  ) : (
                    "NA"
                  )}
                </td>
              </tr>
              <tr>
                <td>All Time High</td>
                <td>
                  {compareCryptoCoinData1[0].high ? (
                    <NumberFormat
                      displayType={"text"}
                      thousandSeparator={true}
                      value={compareCryptoCoinData1[0].high}
                      prefix={`${currencySymbol} `}
                    />
                  ) : (
                    "NA"
                  )}
                </td>
                <td>
                  {compareCryptoCoinData2[0].high ? (
                    <NumberFormat
                      displayType={"text"}
                      thousandSeparator={true}
                      value={compareCryptoCoinData2[0].high}
                      prefix={`${currencySymbol} `}
                    />
                  ) : (
                    "NA"
                  )}
                </td>
                <td>
                  {compareCryptoCoinData2[0].high &&
                  compareCryptoCoinData1[0].high ? (
                    <>
                      <div
                        className="Compare__progressbar__yellow"
                        style={{
                          width: compareProgress(
                            compareCryptoCoinData1[0].high,
                            compareCryptoCoinData2[0].high
                          ),
                        }}
                      ></div>
                      <div
                        className="Compare__progressbar__violet"
                        style={{
                          width: compareProgress(
                            compareCryptoCoinData2[0].high,
                            compareCryptoCoinData1[0].high
                          ),
                        }}
                      ></div>
                    </>
                  ) : (
                    "NA"
                  )}
                </td>
              </tr>
              <tr>
                <td>Market Cap</td>
                <td>
                  {compareCryptoCoinData1[0].market_cap ? (
                    <NumberFormat
                      displayType={"text"}
                      thousandSeparator={true}
                      value={compareCryptoCoinData1[0].market_cap}
                      prefix={`${currencySymbol} `}
                    />
                  ) : (
                    "NA"
                  )}
                </td>
                <td>
                  {compareCryptoCoinData2[0].market_cap ? (
                    <NumberFormat
                      displayType={"text"}
                      thousandSeparator={true}
                      value={compareCryptoCoinData2[0].market_cap}
                      prefix={`${currencySymbol} `}
                    />
                  ) : (
                    "NA"
                  )}
                </td>
                <td>
                  {compareCryptoCoinData2[0].market_cap &&
                  compareCryptoCoinData1[0].market_cap ? (
                    <>
                      <div
                        className="Compare__progressbar__yellow"
                        style={{
                          width: compareProgress(
                            compareCryptoCoinData1[0].market_cap,
                            compareCryptoCoinData2[0].market_cap
                          ),
                        }}
                      ></div>
                      <div
                        className="Compare__progressbar__violet"
                        style={{
                          width: compareProgress(
                            compareCryptoCoinData2[0].market_cap,
                            compareCryptoCoinData1[0].market_cap
                          ),
                        }}
                      ></div>
                    </>
                  ) : (
                    "NA"
                  )}
                </td>
              </tr>
              <tr>
                <td>Trading Volume</td>
                <td>
                  {compareCryptoCoinData1[0]["1d"] &&
                  compareCryptoCoinData1[0]["1d"].volume
                    ? compareCryptoCoinData1[0]["1d"].volume
                    : "NA"}
                </td>
                <td>
                  {compareCryptoCoinData2[0]["1d"] &&
                  compareCryptoCoinData2[0]["1d"].volume
                    ? compareCryptoCoinData2[0]["1d"].volume
                    : "NA"}
                </td>
                <td>
                  {compareCryptoCoinData1[0]["1d"] &&
                  compareCryptoCoinData1[0]["1d"].volume &&
                  compareCryptoCoinData2[0]["1d"] &&
                  compareCryptoCoinData2[0]["1d"].volume ? (
                    <>
                      <div
                        className="Compare__progressbar__yellow"
                        style={{
                          width: compareProgress(
                            compareCryptoCoinData1[0]["1d"].volume,
                            compareCryptoCoinData2[0]["1d"].volume
                          ),
                        }}
                      ></div>
                      <div
                        className="Compare__progressbar__violet"
                        style={{
                          width: compareProgress(
                            compareCryptoCoinData2[0]["1d"].volume,
                            compareCryptoCoinData1[0]["1d"].volume
                          ),
                        }}
                      ></div>
                    </>
                  ) : (
                    "NA"
                  )}
                </td>
              </tr>
              <tr>
                <td>Circulating Supply</td>
                <td>
                  {compareCryptoCoinData1[0].circulating_supply
                    ? compareCryptoCoinData1[0].circulating_supply
                    : "NA"}
                </td>
                <td>
                  {compareCryptoCoinData2[0].circulating_supply
                    ? compareCryptoCoinData2[0].circulating_supply
                    : "NA"}
                </td>
                <td></td>
              </tr>
              <tr>
                <td>Debut Trade</td>
                <td>
                  {compareCryptoCoinData1[0].first_trade
                    ? moment(compareCryptoCoinData1[0].first_trade).format(
                        "yyyy"
                      )
                    : "NA"}
                </td>
                <td>
                  {compareCryptoCoinData2[0].first_trade
                    ? moment(compareCryptoCoinData2[0].first_trade).format(
                        "yyyy"
                      )
                    : "NA"}
                </td>
                <td></td>
              </tr>
              <tr>
                <td>Number of Exchanges</td>
                <td>
                  {compareCryptoCoinData1[0].num_exchanges
                    ? compareCryptoCoinData1[0].num_exchanges
                    : "NA"}
                </td>
                <td>
                  {compareCryptoCoinData2[0].num_exchanges
                    ? compareCryptoCoinData2[0].num_exchanges
                    : "NA"}
                </td>
                <td></td>
              </tr>
              <tr>
                <td>Number of Pairs</td>
                <td>
                  {compareCryptoCoinData1[0].num_pairs
                    ? compareCryptoCoinData1[0].num_pairs
                    : "NA"}
                </td>
                <td>
                  {compareCryptoCoinData2[0].num_pairs
                    ? compareCryptoCoinData2[0].num_pairs
                    : "NA"}
                </td>
                <td></td>
              </tr>
              <tr>
                <td>Dominance</td>
                <td>
                  {compareCryptoCoinData1[0].market_cap_dominance
                    ? compareCryptoCoinData1[0].market_cap_dominance
                    : "NA"}
                </td>
                <td>
                  {compareCryptoCoinData2[0].market_cap_dominance
                    ? compareCryptoCoinData2[0].market_cap_dominance
                    : "NA"}
                </td>
                <td></td>
              </tr>
            </table>
          </div>
        ) : (
          <>
            <Loader />
          </>
        )}
      </div>
    </div>
  );
};

export default Compare;
